export default __webpack_public_path__ + "static/media/HS-icon.ae44b503.svg";